/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for selectListControlType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="selectListControlType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="automatic"/&gt; &lt;enumeration value="allQueryItems"/&gt; &lt;enumeration value="usedQueryItems"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class SelectListControlType extends Enum{

	enumValue = null;

	/**
	 * server determined.
	 */
	static  AUTOMATIC = SelectListControlType.newLiteral("automatic");

	/**
	 * SQL Select contains all columns of the querysubject.
	 */
	static  ALL_QUERY_ITEMS = SelectListControlType.newLiteral("allQueryItems");

	/**
	 * SQL Select contains used columns.
	 */
	static  USED_QUERY_ITEMS = SelectListControlType.newLiteral("usedQueryItems");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < SelectListControlType.values().length); ++i) {
			if (SelectListControlType.values()[i].enumValue == v) {
				return SelectListControlType.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("SelectListControlType" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/SelectListControlType.js